module.exports = {"340210100":"湾沚镇","340210101":"陶辛镇","340210102":"六郎镇","340210103":"花桥镇","340210104":"红杨镇","340210400":"安徽新芜经济开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340210.json
// module id = 1155
// module chunks = 0